import { ColorType, TouchableBox, useLayoutContext } from "arkh";
import React, { PropsWithChildren } from "react";

export function Item({
  onPress,
  children,
  color = "surface",
  borderColor,
}: PropsWithChildren<{
  onPress?: () => void;
  color?: ColorType;
  borderColor?: ColorType;
}>) {
  const layout = useLayoutContext();
  return (
    <TouchableBox
      onPress={onPress}
      borderColor="border-primary"
      cornerRadius="large"
      space="xsmall"
      spaceHorizontal="small"
      color={color}
      style={{
        height: layout.circle.medium,
        alignSelf: "stretch",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        borderWidth: 1,
      }}
    >
      {children}
    </TouchableBox>
  );
}
